import axios from 'axios'
import Tax from '@/dto/taxes/Tax'

const TaxesService = {
  loadTaxes(): Promise<Tax[]> {
    return axios.get(`/admin/taxes`).then(response => response.data.taxes)
  },
  saveTax(tax: Tax): Promise<Tax> {
    const request = tax.id
      ? axios.put(`/admin/taxes/${tax.id}`, tax)
      : axios.post('/admin/taxes', tax)

    return request.then(response => response.data.tax)
  },
  deleteTax(taxId: number) {
    return axios.delete(`/admin/taxes/${taxId}`)
  },
}

export default TaxesService
